import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './hooks/useAuth';
import { AuthGate } from './components/AuthGate';
import { configureAmplify } from './lib/amplify';
import App from './App';
import './styles/app.css';
import './styles/login.css';

configureAmplify();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <AuthGate>
        <App />
      </AuthGate>
    </AuthProvider>
  </StrictMode>,
);
